import React, { useState, useEffect } from "react";
import axios from "../../utils/axiosInstance";
import Button from "../ui/Button";

const AttachFromSetModal = ({ projectId, onClose, onSuccess }) => {
  const [taskSets, setTaskSets] = useState([]);
  const [selectedSet, setSelectedSet] = useState(null);
  const [loading, setLoading] = useState(false);
  const [attaching, setAttaching] = useState(false);

  useEffect(() => {
    fetchTaskSets();
  }, []);

  // Lock body scroll when modal is open
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  const fetchTaskSets = async () => {
    setLoading(true);
    try {
      const res = await axios.get("/registry/task-sets", {
        params: { status: "published", limit: 100 }
      });
      setTaskSets(res.data.items || []);
    } catch (error) {
      console.error("Error fetching task sets:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleAttach = async () => {
    if (!selectedSet) return;

    setAttaching(true);
    try {
      await axios.post(`/task-bundles/projects/${projectId}/task-bundles/from-set`, {
        setId: selectedSet._id
      });
      onSuccess && onSuccess();
    } catch (error) {
      console.error("Error attaching task set:", error);
      alert("Failed to attach task set");
    } finally {
      setAttaching(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <h2 className="text-xl font-bold mb-4">Attach Task Set</h2>

          {loading ? (
            <p className="text-gray-500">Loading task sets...</p>
          ) : taskSets.length === 0 ? (
            <p className="text-gray-500">No published task sets available.</p>
          ) : (
            <div className="space-y-3 mb-6">
              {taskSets.map((set) => (
                <label
                  key={set._id}
                  className={`block p-4 border rounded cursor-pointer transition-colors ${
                    selectedSet?._id === set._id
                      ? 'border-blue-500 bg-blue-50'
                      : 'border-gray-200 hover:border-gray-300'
                  }`}
                >
                  <input
                    type="radio"
                    name="taskSet"
                    value={set._id}
                    checked={selectedSet?._id === set._id}
                    onChange={() => setSelectedSet(set)}
                    className="mr-3"
                  />
                  <div className="inline-block">
                    <div className="font-medium">{set.name}</div>
                    <div className="text-sm text-gray-600">{set.description}</div>
                    <div className="text-xs text-gray-500 mt-1">
                      {set.taskRefs?.length || 0} task(s) • Version {set.version}
                    </div>
                  </div>
                </label>
              ))}
            </div>
          )}

          <div className="flex justify-end gap-2">
            <Button type="button" variant="outline" onClick={onClose}>
              Cancel
            </Button>
            <Button
              type="button"
              variant="solid"
              onClick={handleAttach}
              disabled={!selectedSet || attaching}
            >
              {attaching ? "Attaching..." : "Attach"}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AttachFromSetModal;
